export default {"src":"/_next/static/media/ChooseIocn1.4857f109.svg","height":56,"width":51};